import { WallShortcutComponent } from './pages/community/wall-shortcut.component';
import { ChatDockComponent } from './pages/communication/components/chat-dock.component';
import { CommunicationService } from './pages/communication/services/communication.service';
import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NavigationService } from './core/navigation/navigation.service';
import { RealtimeService } from './services/realtime.service';
import { AdminService } from './services/admin.service';
import { LiveNotificationService } from './services/live-notification.service';
import { MailService } from './pages/mail/services/mail.service';
import { ClientControlService } from './services/client-control.service';
import { ClientNoticeBannerComponent } from './shared/components/client-notice-banner/client-notice-banner.component';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, NgIf, ClientNoticeBannerComponent, ChatDockComponent, WallShortcutComponent]
})
export class AppComponent {
  constructor(
    private realtime: RealtimeService,
    private adminService: AdminService,
    private liveNotification: LiveNotificationService,
    private mailService: MailService,
    private communication: CommunicationService,
    public clientControl: ClientControlService
  ) {

  }

  ngOnInit() {
    this.communication.startPresence();
    void this.clientControl.load();
    const baseUrl = this.adminService.BaseUriimage;
    this.liveNotification.init();
    this.mailService.startBackgroundMailSync();
    this.realtime.init(baseUrl);

    this.realtime.qacFeedbackCreated$.subscribe((data: any) => {
      this.liveNotification.pushRealtime({
        type: 'feedback',
        title: data?.title || 'New Feedback',
        message: data?.message || data?.issue || 'A new feedback has been submitted.',
        route: data?.route || '/qac/feedback-list',
        icon: 'mat:feedback',
        colorClass: 'text-orange-600',
        data
      });
    });

    this.realtime.qacChecklistCommentCreated$.subscribe((data: any) => {
      this.liveNotification.pushRealtime({
        type: 'checklist-comment',
        title: data?.title || 'New Checklist Comment',
        message: data?.message || data?.issue || 'A checklist comment is added.',
        route: data?.route || '/qac/checklistexec',
        icon: 'mat:comment',
        colorClass: 'text-primary-600',
        data
      });
    });

    this.realtime.notificationUnreadCountChanged$.subscribe((data: any) => {
      const count = Number(data?.unread_count ?? data?.count ?? 0);
      this.liveNotification.setUnreadCountFromRealtime(count);
    });
  }
}
